// PURPOSE: Shared catalog query and model lookup. CONTRACT: only server-visible schemas. DEPENDS: authenticated native API and React Query. CEILING: no client-side permission grants.
import { useQuery } from '@tanstack/react-query';
import { useSession } from './auth';
export function useCatalog() { const { api } = useSession(); return useQuery({ queryKey: ['catalog'], queryFn: () => api.catalog(), staleTime: 60_000 }); }
